export default __webpack_public_path__ + "static/deega-9409093bbbc1086ff07ead8e5f3232d8.svg";